// src/Pages/ForgotPassword.js
import { useState } from 'react';
import { supabase } from '../supabaseClient';
import { Link, useNavigate } from 'react-router-dom';
import { useIsMobile } from '../hooks/useMediaQuery'; // ADD THIS

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const isMobile = useIsMobile(); // ADD THIS

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });

    if (error) {
      setMessage(error.message);
    } else {
      setMessage('✓ Check your email for the reset link!');
    }
    setLoading(false);
  };

  return (
    <div style={getContainerStyle(isMobile)}>
      <button 
        onClick={() => navigate('/login')} 
        style={getBackButtonStyle(isMobile)}
      >
        ←
      </button>
      
      <div style={getContentStyle(isMobile)}>
        <h1 style={getTitleStyle(isMobile)}>Forgot Password?</h1>
        <p style={getSubtitleStyle(isMobile)}>
          Enter your email and we'll send you a reset link
        </p>

        <form onSubmit={handleReset} style={getFormStyle(isMobile)}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            style={getInputStyle(isMobile)}
          />
          
          <button 
            type="submit" 
            disabled={loading}
            style={loading ? {...getButtonStyle(isMobile), ...buttonDisabledStyle} : getButtonStyle(isMobile)}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        {message && (
          <div style={message.includes('✓') ? successMessageStyle : errorMessageStyle}>
            {message}
          </div>
        )}

        <p style={getFooterStyle(isMobile)}>
          Remember your password? <Link to="/login" style={linkStyle}>Log In</Link>
        </p>
      </div>
    </div>
  );
}

// Dynamic style functions
const getContainerStyle = (isMobile) => ({
  minHeight: '100vh',
  background: '#1a1b1e',
  display: 'flex',
  flexDirection: 'column',
  padding: isMobile ? '16px' : '20px',
  position: 'relative',
});

const getBackButtonStyle = (isMobile) => ({
  position: 'absolute',
  top: isMobile ? '16px' : '20px',
  left: isMobile ? '16px' : '20px',
  background: 'transparent',
  border: 'none',
  color: '#fff',
  fontSize: isMobile ? '28px' : '24px',
  cursor: 'pointer',
  minWidth: '44px', // Touch target
  minHeight: '44px', // Touch target
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
  transition: 'background 0.2s',
});

const getContentStyle = (isMobile) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  maxWidth: '400px',
  width: '100%',
  margin: '0 auto',
  padding: isMobile ? '60px 0 40px' : '0', // Extra top padding for back button on mobile
});

const getTitleStyle = (isMobile) => ({
  color: '#fff',
  fontSize: isMobile ? '28px' : '24px',
  fontWeight: 'bold',
  margin: '0 0 12px 0',
  textAlign: 'center',
});

const getSubtitleStyle = (isMobile) => ({
  color: '#b5bac1',
  fontSize: isMobile ? '15px' : '14px',
  margin: '0 0 30px 0',
  textAlign: 'center',
  lineHeight: '1.5',
  padding: isMobile ? '0 10px' : '0',
});

const getFormStyle = (isMobile) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: isMobile ? '16px' : '20px',
  width: '100%',
});

const getInputStyle = (isMobile) => ({
  padding: isMobile ? '16px' : '12px 16px',
  borderRadius: '12px',
  border: 'none',
  background: '#1e1f22',
  color: '#fff',
  fontSize: '16px', // Prevents iOS zoom
  minHeight: '48px', // Touch target
  width: '100%',
  boxSizing: 'border-box',
});

const getButtonStyle = (isMobile) => ({
  padding: isMobile ? '16px' : '14px',
  borderRadius: '12px',
  border: 'none',
  background: '#5865f2',
  color: '#fff',
  fontSize: isMobile ? '17px' : '16px',
  fontWeight: '600',
  cursor: 'pointer',
  minHeight: '52px', // Larger touch target
  width: '100%',
  transition: 'transform 0.1s, opacity 0.2s',
});

const buttonDisabledStyle = {
  opacity: 0.5,
  cursor: 'not-allowed',
};

const successMessageStyle = {
  marginTop: '20px',
  padding: '14px',
  borderRadius: '10px',
  background: 'rgba(35, 165, 90, 0.1)',
  color: '#23a55a',
  textAlign: 'center',
  fontSize: '14px',
  lineHeight: '1.5',
};

const errorMessageStyle = {
  marginTop: '20px',
  padding: '14px',
  borderRadius: '10px',
  background: 'rgba(242, 63, 66, 0.1)',
  color: '#f23f42',
  textAlign: 'center',
  fontSize: '14px',
  lineHeight: '1.5',
};

const getFooterStyle = (isMobile) => ({
  color: '#72767d',
  fontSize: isMobile ? '15px' : '14px',
  textAlign: 'center',
  marginTop: isMobile ? '40px' : '30px',
  lineHeight: '1.6',
});

const linkStyle = {
  color: '#00a8fc',
  textDecoration: 'none',
  fontWeight: '500',
};